/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SecondaryAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import Letter from './Letter/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function SecondaryAction({
  children,
  viewPath = "/DesignSystem/TasksViewForm/Content/Content/Actions/OldAction/Action/SecondaryAction"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let actionTypeValueData = fromData.useDataValue({ viewPath,
context: 'action',
path: 'type',
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: actionTypeValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Letter'}>
<Letter
  viewPath={`${viewPath}/Letter`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}